var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "verification",
    style: {
      backgroundColor: _vm.showIcon ? '#f1f2f5' : '#fff'
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showIcon,
      expression: "showIcon"
    }],
    staticClass: "lock"
  }, [_c('Icon', {
    staticStyle: {
      "line-height": "32px",
      "color": "#bcc4d0"
    },
    attrs: {
      "size": "32",
      "type": "md-lock"
    }
  })], 1), _vm._l(_vm.title, function (tip, index) {
    return _c('div', {
      key: index,
      staticClass: "info"
    }, [_vm._v(" " + _vm._s(tip) + " ")]);
  }), _c('div', {
    ref: "inputList",
    staticClass: "verification-container"
  }, _vm._l(_vm.verificationCodes, function (code, index) {
    return _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.verificationCodes[index],
        expression: "verificationCodes[index]"
      }],
      key: index,
      staticClass: "verification-input",
      attrs: {
        "type": "tel",
        "maxlength": "1"
      },
      domProps: {
        "value": _vm.verificationCodes[index]
      },
      on: {
        "focus": function ($event) {
          return _vm.handleFocus(index, $event);
        },
        "input": [function ($event) {
          if ($event.target.composing) return;
          _vm.$set(_vm.verificationCodes, index, $event.target.value);
        }, function ($event) {
          return _vm.handleInput(index, $event);
        }],
        "keydown": function ($event) {
          return _vm.handleKeyDown(index, $event);
        }
      }
    });
  }), 0)], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };